/* I LOVE DUFT — Wishlist (localStorage based)
   Works on product cards site-wide + a dedicated wishlist page (.js-wishlistBlock)
   Storage key: 'wishlist' -> [{ productId, productTitle, productImg, productPrice, productUrl }] */
(function () {
  'use strict';

  var KEY = 'wishlist';

  /* Localized UI strings (set from Liquid on the wishlist page) with safe fallbacks */
  function t(key, fallback) {
    var s = window.ILDWishlistStrings || {};
    return s[key] || fallback;
  }

  /* Locale-aware shop root (e.g. "/" or "/en/") */
  function cartRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function read() {
    try {
      var data = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function has(list, id) {
    return list.some(function (item) {
      return String(item.productId) === String(id);
    });
  }

  function toggle(data) {
    var list = read();
    if (has(list, data.productId)) {
      list = list.filter(function (item) {
        return String(item.productId) !== String(data.productId);
      });
    } else {
      list.push(data);
    }
    write(list);
    syncButtons();
    updateCount();
    renderPage();
    return list;
  }

  function remove(id) {
    var list = read().filter(function (item) {
      return String(item.productId) !== String(id);
    });
    write(list);
    syncButtons();
    updateCount();
    renderPage();
  }

  /* Reflect saved state on every card toggle button currently in the DOM */
  function syncButtons() {
    var list = read();
    document.querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
      var active = has(list, btn.getAttribute('data-wishlist-id'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var card = btn.closest('.ild-card');
      if (card) card.classList.toggle('is-wishlisted', active);
    });
  }

  function updateCount() {
    var count = read().length;
    document.querySelectorAll('.wishlist-count-bubble').forEach(function (bubble) {
      bubble.textContent = count > 99 ? '99+' : count;
      bubble.classList.toggle('is-visible', count > 0);
    });
  }

  /* Render the wishlist page grid (if present) */
  function renderPage() {
    var block = document.querySelector('.js-wishlistBlock');
    if (!block) return;

    var list = read();
    var empty = document.querySelector('.js-wishlistEmpty');
    var actions = document.querySelector('.js-wishlistActions');

    if (!list.length) {
      block.innerHTML = '';
      if (empty) empty.style.display = '';
      if (actions) actions.hidden = true;
      return;
    }
    if (empty) empty.style.display = 'none';
    if (actions) actions.hidden = false;

    var moodOn = !(window.ILDWishlistConfig && window.ILDWishlistConfig.moodAtmosphere === false);
    var viewLabel = escapeHtml(t('view_product', 'View product'));
    var removeLabel = escapeHtml(t('remove', 'Remove from wishlist'));

    block.innerHTML = list
      .map(function (item) {
        var title = escapeHtml(item.productTitle || '');
        var url = escapeHtml(item.productUrl || '#');
        var img = escapeHtml(item.productImg || '');
        var price = escapeHtml(item.productPrice || '');
        var id = escapeHtml(String(item.productId || ''));
        var mood = escapeHtml(String(item.productMood || 'default'));
        var bg = item.productBg ? escapeHtml(String(item.productBg)) : '';
        var media = img
          ? '<img class="ild-card__image" src="' + img + '" alt="' + title + '" loading="lazy">'
          : '';
        var cardClass = 'ild-card' + (moodOn ? ' ild-card--mood' : '');
        var mediaStyle = bg
          ? ' style="background: radial-gradient(125% 125% at 50% 16%, ' + bg + ' 0%, ' + bg + ' 72%);"'
          : '';
        return (
          '<div class="' + cardClass + '" data-product-id="' + id + '" data-mood="' + mood + '">' +
            '<div class="ild-card__media ild-ratio-square"' + mediaStyle + '>' +
              '<button type="button" class="ild-wish-remove js-wishlist-remove" data-wishlist-id="' + id + '" aria-label="' + removeLabel + '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
              '</button>' +
              '<a href="' + url + '" class="ild-card__image-link" aria-label="' + title + '">' + media + '</a>' +
            '</div>' +
            '<div class="ild-card__body">' +
              '<a href="' + url + '" class="ild-card__title-link"><h3 class="ild-card__title">' + title + '</h3></a>' +
              '<div class="ild-card__divider"></div>' +
              '<div class="ild-card__meta"><span class="ild-card__price">' + price + '</span></div>' +
              '<a href="' + url + '" class="ild-card__atc" style="text-decoration:none;">' + viewLabel + '</a>' +
            '</div>' +
          '</div>'
        );
      })
      .join('');
  }

  /* Resolve a buyable variant id for a wishlist item (uses the stored id, else fetches the product) */
  function resolveVariant(item) {
    if (item.productVariant) return Promise.resolve(item.productVariant);
    if (!item.productUrl) return Promise.resolve(null);
    var u = item.productUrl.split('?')[0].replace(/\/$/, '') + '.js';
    return fetch(u)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return null;
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        return v ? v.id : null;
      })
      .catch(function () { return null; });
  }

  /* Add every wishlist item to the cart, then go to the cart */
  function addAllToCart(btn) {
    var list = read();
    if (!list.length) return;
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    var original = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', original);
    btn.classList.add('is-loading');
    btn.textContent = t('adding', 'Adding…');

    Promise.all(list.map(resolveVariant))
      .then(function (ids) {
        var items = ids
          .filter(Boolean)
          .map(function (id) { return { id: id, quantity: 1 }; });
        if (!items.length) throw new Error('no-variants');
        return fetch(cartRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        window.location.href = cartRoot() + 'cart';
      })
      .catch(function () {
        btn.dataset.busy = '';
        btn.classList.remove('is-loading');
        btn.textContent = original;
        window.alert(t('error', 'Something went wrong. Please try again.'));
      });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Event delegation — survives AJAX-loaded cards & section reloads */
  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('.js-wishlist-toggle');
    if (toggleBtn) {
      e.preventDefault();
      toggle({
        productId: toggleBtn.getAttribute('data-wishlist-id'),
        productTitle: toggleBtn.getAttribute('data-wishlist-title'),
        productImg: toggleBtn.getAttribute('data-wishlist-img'),
        productPrice: toggleBtn.getAttribute('data-wishlist-price'),
        productUrl: toggleBtn.getAttribute('data-wishlist-url'),
        productVariant: toggleBtn.getAttribute('data-wishlist-variant'),
        productMood: toggleBtn.getAttribute('data-wishlist-mood'),
        productBg: toggleBtn.getAttribute('data-wishlist-bg')
      });
      return;
    }
    var removeBtn = e.target.closest('.js-wishlist-remove');
    if (removeBtn) {
      e.preventDefault();
      remove(removeBtn.getAttribute('data-wishlist-id'));
      return;
    }
    var addAllBtn = e.target.closest('.js-wishlist-add-all');
    if (addAllBtn) {
      e.preventDefault();
      addAllToCart(addAllBtn);
    }
  });

  function init() {
    syncButtons();
    updateCount();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor / dynamic sections
  document.addEventListener('shopify:section:load', init);

  // Expose for debugging / external use
  window.ILDWishlist = { read: read, toggle: toggle, remove: remove, refresh: init };
})();
